import React from 'react'
import './skeleton-loader.css'

const SkeletonLoader = () => {
  return (
    <div className='skeleton_loader_main_div'>
      {/* Skeleton for Recommended Card */}
      <div className='skeleton_loader_card_div'>
        <div className='left_sec_box skeleton_loader_cls'></div>
        <div className='right_sec_box'>
          <div
            className='skeleton_loader_cls'
            style={{ width: '100px', height: '24px', borderRadius: '12px', marginBottom: '12px' }}
          ></div>{' '}
          {/* Tag placeholder */}
          <div
            className='skeleton_loader_cls'
            style={{ width: '80%', height: '28px', marginBottom: '10px' }}
          ></div>{' '}
          {/* Story Title placeholder */}
          <div
            className='skeleton_loader_cls'
            style={{ width: '90%', height: '20px', marginBottom: '15px' }}
          ></div>{' '}
          {/* English Title placeholder */}
          <div className='skeleton_loader_cls' style={{ width: '70%', height: '20px' }}></div>{' '}
          {/* Footer placeholder */}
        </div>
      </div>

      {/* Skeleton for Featured Story Card */}
      <div className='skeleton_loader_card_div' style={{ padding: '20px 25px', display: 'block', minHeight: 'auto' }}>
        <div className='skeleton_loader_cls' style={{ width: '85%', height: '20px', marginBottom: '12px' }}></div>{' '}
        {/* "Want to learn more..." placeholder */}
        <div className='skeleton_loader_cls' style={{ width: '65%', height: '26px', marginBottom: '8px' }}></div>{' '}
        {/* Main story title placeholder */}
        <div className='skeleton_loader_cls' style={{ width: '75%', height: '20px' }}></div>{' '}
        {/* English title placeholder */}
      </div>
    </div>
  )
}

export default SkeletonLoader
